<template>
  <div>
    {{ ActDescBtn }}
    <table
        :height="this.windowSize.height - 8"
        :max-height="this.windowSize.height - 8"
        style="position: absolute"
        width="100%"
    >
      <tr height="48px" max-height="48px">
        <ContenidoBase
            :EstadoBtn="EstadoBtn"
            :descripcion="'Utilitario Factura Ventas'"
            :titulo="'Utilitario Factura Ventas'"
            @MethodAnular="anular"
            @MethodEliminar="remove"
            @MethodGuardar="save"
            @MethodImprimir="imprimirList"
            @MethodNuevo="newwnuevo"
            @abrirBarraTablaDinamica="abrirTabla"
        />
      </tr>

      <!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td v-show="BarraPrimariaAbrir" :max-height="this.windowSize.height - 96" width="109">
        <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
        >
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <center>
                <v-btn-toggle>
                  <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                    <i class="fa fa-eye" style="font-size: 25px"></i>
                    ver
                  </v-btn>
                  <v-btn color="deep-purple accent-2" dark small @click.prevent="notifi('Seguro que desea nuevo', 'n')">
                    <i class="fa fa-print" style="font-size: 25px"></i>
                    Listado
                  </v-btn>
                </v-btn-toggle>
              </center>
              <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitUtilitarioRecIng'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
            </template>
          </v-tooltip>
        </div>
      </td>
      <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
      <!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height - 96">
        <v-app id="inspire" class="overflow-y-auto" v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
          <div class="px-2">
            <v-card color="grey lighten-3">
              <div class="px-2" style="border: 1px solid #000000">
                <v-form ref="formFactVenta" v-model="valid" lazy-validation @submit.prevent="">
                  <!-- row 1  ---------------------------------------->
                  <v-row>
                    <v-col cols="12" md="3" sm="3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                              id="fecha-inicial"
                              v-model="busquedaFacVent.fechaInicial"
                              :rules="[$rules.required]"
                              dense
                              label="Fecha Inicial"
                              outlined
                              placeholder=" "
                              style="font-size: 12px"
                              type="date"
                              @blur="BlurDesde"
                              @input="getFacVenta"
                              v-on="on"
                              v-on:input="resertPaginacion"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 18px"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Aquí se registra la fecha a partir de la cual queremos la búsqueda.</span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12" md="3" sm="3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                              v-model="busquedaFacVent.fechaFinal"
                              :rules="[$rules.required]"
                              dense
                              label="Fecha Final"
                              outlined
                              placeholder=" "
                              style="font-size: 12px"
                              type="date"
                              @blur="BlurHasta"
                              @input="getFacVenta"
                              v-on="on"
                              v-on:input="resertPaginacion"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 18px"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Aquí se registra la fecha hasta donde queremos la búsqueda.</span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12" md="6" sm="6">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-combobox
                              v-model="busquedaFacVent.documento"
                              :items="RDocumento"
                              autocomplete="off"
                              dense
                              item-text="descripcion"
                              label="Documentos:"
                              outlined
                              style="font-size: 13px"
                              @blur="SelctCbDocumentoBuscar"
                              @change="getFacVenta"
                              @focus="cargarDocumento"
                              v-on="on"
                              v-on:change="resertPaginacion"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-book" style="font-size: 20px"></i>
                            </template>
                          </v-combobox>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Se registra el documento de factura de venta que se desea buscar..</span>
                        </i>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <!-- fn row 1  ---------------------------------------->

                  <!-- row 2  ---------------------------------------->
                  <v-row style="margin-top: -23px">
                    <v-col cols="12" md="4" sm="4">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <!-- Factura No --------------------------------------------------->
                          <v-text-field
                              v-model.number="busquedaFacVent.NoFactura"
                              autocomplete="off"
                              dense
                              label="No.Factura:"
                              outlined
                              placeholder=" "
                              style="font-size: 12px"
                              @input="getFacVenta"
                              @keyup="KeyUpCantidad"
                              v-on="on"
                              v-on:input="resertPaginacion"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-slack" style="font-size: 18px"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Se registra el número de factura de venta que se desea buscar.</span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12" md="8" sm="8">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-combobox
                              v-model="busquedaFacVent.cliente"
                              :items="RCliente"
                              :suffix="clientTel"
                              autocomplete="off"
                              dense
                              item-text="nombre"
                              label="cliente:"
                              outlined
                              style="font-size: 13px"
                              @blur="SelctCbClienteBuscar"
                              @change="getFacVenta"
                              @focus="cargarCliente"
                              @keyup="CbFilcliente"
                              v-on="on"

                          >
                            <template v-slot:prepend>
                              <i class="fa fa-user-circle" style="font-size: 20px"></i>
                            </template>
                          </v-combobox>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Se selecciona el cliente que desea buscar.</span>
                        </i>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <!-- fn row 2  ---------------------------------------->
                  <!-- row 3  ---------------------------------------->
                  <v-row style="margin-top: -23px">
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field
                          v-model="busquedaFacVent.ncf"
                          autocomplete="off"
                          dense
                          label="NCF"
                          outlined
                          @blur="getFacVenta"
                          v-on:blur="resertPaginacion"
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-barcode" style="font-size: 20px"></i>
                        </template>
                      </v-text-field>
                    </v-col>
                    <!-- columna 1 -->
                    <v-col class="pt-0 mt-0" cols="12" md="6" sm="6">
                      <center>
                        <!-- class="pa-0 ma-0 py-0 my-0" :class="`d-flex justify-center white--text`"-->
                        <!-- <v-row no-gutters></v-row> -->
                        <span style="font-size: 12px"><b>OPCION FAC. ELECTRÓNICO:</b>
                          <!-- <span style="color: #C62828;"> Para </span> --> </span>
                        <v-radio-group v-model="busquedaFacVent.opcion" class="pt-0 mt-0 d-flex justify-center " dense
                                       hide-details
                                       row @change="getFacVenta">
                          <!-- <v-radio label="RUTINARIOS" color="green" :value="1"></v-radio>
                          <v-radio label="NO RUTINARIOS" color="green" :value="2"></v-radio>-->
                          <v-radio :value="0" color="green" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">TODOS</strong>
                            </template>
                          </v-radio>
                          <v-radio id="no-enviada" :value="1" color="green" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">NO ENVIADA</strong>
                            </template>
                          </v-radio>

                          <v-radio :value="2" color="green" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">ENVIADA</strong>
                            </template>
                          </v-radio>


                        </v-radio-group>
                        <v-text-field v-if="busquedaFacVent.opcion==2" v-model="busquedaFacVent.buscarTrackId"
                                      autocomplete="off"
                                      class="pt-0 mt-0 fontSize12"
                                      dense hide-details label="" single-line style="border:1px solid #000000;"
                                      @blur="getFacVenta">
                          <template v-slot:prepend-inner>
                            <i class="fa fa-search" style="font-size: 20px;"></i>
                          </template>
                          <template v-slot:label>
                            <!-- <strong style="color: #000000; font-size: 11px">BUSCAR CON REF:(Aceptado/Rechazado)</strong> -->
                            <span style="font-size: 11px">BUSCAR CON REF:(Aceptado/Rechazado)</span>
                          </template>
                        </v-text-field>
                      </center>

                    </v-col>
                    <!-- fn columna 1 -->
                  </v-row>
                  <!-- fn row 3  ---------------------------------------->
                </v-form>

                <v-row>
                  <v-col cols="12" md="12" sm="12" style="margin-top: -25px">
                    <div style="border: 1px solid #000000">
                      <!-- @click:row="datostabla" -->
                      <v-data-table
                          v-if="resertPagi == true"
                          id="facturas-table"
                          v-model="selected"
                          :footer-props="arrayPropiedases"
                          :headers="[
                          { text: 'Fecha', sortable: false, value: 'fecha', width: 120 },
                          { text: 'Documento', sortable: false, value: 'documentoFactura.descripcion', width: 200 },
                          { text: 'Factura', sortable: false, value: 'facturasventaPK.secuencia', width: 129 },
                          { text: 'NCF', sortable: false, value: 'ncf', width: 129 },
                          { text: 'Cliente', sortable: false, value: 'clinica.nombre', width: 129 },
                          { text: 'Sucursal', sortable: false, value: 'sucursal.descripcion', width: 150 },
                          { text: 'Valor', sortable: false, value: 'valor', width: 'auto', width: 105 },
                        ]"
                          :items="listFactVent"
                          :items-per-page="paginator.itemsPerPage"
                          :search="search"
                          :server-items-length="TotalRegistros"
                          :show-select="true"
                          :single-select="true"
                          class="RowSelectColor"
                          dense
                          item-key="indx"
                          @pagination="cargarPaginacion"
                          @item-selected="obtenerDatoSelect"
                          @click:row="datostabla"
                      >
                        <template v-slot:item.action="{ item }">
                          <!-- <v-btn fab @click.prevent="VerReporte(item)" x-small color="yellow accent-4"><i style="font-size: 20px;" class="fa fa-eye"></i></v-btn>  -->
                          <v-btn color="red darken-3" fab x-small @click.prevent="deleFact(item)">
                            <i class="fa fa-trash-o" style="font-size: 20px"></i>
                          </v-btn>
                        </template>

                        <template v-slot:item.fecha="props">
                          <span style="font-size: 13px; display: none">
                            {{ (props.item.indx = listFactVent.indexOf(props.item)) }}
                          </span>
                          <span style="font-size: 13px">{{ FormatoFecha(props.item.fecha) }}</span>
                        </template>

                        <template v-slot:item.documentoFactura.descripcion="props">
                          <span style="font-size: 13px">{{ props.item.documentoFactura.descripcion }}</span>
                        </template>

                        <template v-slot:item.facturasventaPK.secuencia="props">
                          <span :class="asignClaseFactura(props.item)" style="font-size: 13px">{{
                              props.item.facturasventaPK.secuencia
                            }}</span>
                        </template>
                        <template v-slot:item.ncf="props">
                          <span style="font-size: 13px">{{ props.item.ncf }}</span>
                        </template>

                        <template v-slot:item.clinica.nombre="props">
                          <span v-if="props.item.cliente != null" style="font-size: 13px">
                            {{ props.item.cliente.nombre }}
                          </span>
                        </template>

                        <template v-slot:item.sucursal.descripcion="props">
                          <span v-if="props.item.sucursal != null" style="font-size: 13px">
                            {{ props.item.sucursal.descripcion }}
                          </span>
                        </template>

                        <template v-slot:item.valor="props">
                          <span style="font-size: 13px">{{ currencyFormatter(props.item.valor) }}</span>
                        </template>

                        <!-- <template v-slot:body.append v-if="windowSize.width >600">
<tr>  
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong class="d-flex justify-end" style="font-size:11px; color: #00838F;">Total de horas:</strong></td>
         
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(Totales.totalHora)}} </strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
  </tr>
 </template>
<template v-slot:footer v-if="windowSize.width<=600">
<v-list-item style="font-size: 70%;" class="white--text" > 
      <v-list-item-content>
        <span>Total de horas:{{currencyFormatter(Totales.totalHora)}} </span>
      

      </v-list-item-content>
    </v-list-item>

  </template> -->
                      </v-data-table>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
            <hr/>
            <v-card color="grey lighten-3">
              <div class="px-2 pt-1" style="border: 1px solid #000000">

                <!-- Facturacion Electronica -->
                <v-col v-if="activarModuloEletronica(UtilFacturaVentas)==true" class="pa-0 ma-0 py-0 my-0"
                       cols="12" md="12" sm="12" style="border: 1px dashed  #616161;">
                  <v-card>
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#BDBDBD;">
                      <span><b>Facturación Electrónica</b></span>
                    </v-col>

                    <!-- cuerpo FACTURACION ELETRONICA -->
                    <v-col cols="12" md="12" sm="12">
                      <v-row>
                        <v-col class="py-0 my-0" cols="12" md="4" sm="4">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">

                              <v-btn id="actualizar-factura" color="blue" dark outlined
                                     small v-on="on" @click.prevent="actualizarFacEletronico(UtilFacturaVentas)">
                                <i class="fa fa-plus-square" style="font-size: 20px;"></i> ACTUALIZAR FACT.ELECTRONICA
                              </v-btn>

                            </template>
                            <span>ACTUALIZAR FACT.ELECTRONICA</span>
                          </v-tooltip>
                        </v-col>

                        <v-col class="py-0 my-0" cols="12" md="4" sm="4">
                          <v-text-field id="formdisabledInput" :value="UtilFacturaVentas.signatureValue"
                                        autocomplete="off" dense
                                        disabled
                                        hide-details label=" signatureValue:" outlined style="font-size:13px;">
                            <template v-slot:prepend>
                              <i class="fa fa-shield" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col class="py-0 my-0" cols="12" md="4" sm="4">
                          <v-text-field id="formdisabledInput" :value="UtilFacturaVentas.fechafirmadgii"
                                        autocomplete="off"
                                        dense disabled
                                        hide-details label="fechafirmadgii" outlined style="font-size:13px;">
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
                          <v-textarea id="formdisabledInput" :value="UtilFacturaVentas.qrdgii" auto-grow
                                      autocomplete="off" dense
                                      disabled hide-details label="QR:" outlined
                                      rows="1">
                            <template v-slot:prepend>
                              <i class="fa fa-commenting" style="font-size: 20px;"></i>
                            </template>
                          </v-textarea>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
                          <v-textarea id="formdisabledInput" :value="UtilFacturaVentas.trackId" auto-grow
                                      autocomplete="off" dense
                                      hide-details label="trackId:" outlined rows="1">
                            <template v-slot:prepend>
                              <i class="fa fa-commenting" style="font-size: 20px;"></i>
                            </template>
                          </v-textarea>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
<pre style="font-size: 10px;">
  AMBIENTE:(testecf/certecf/ecf)
  CONSULTA:
  1- https://ecf.dgii.gov.do/{AMBIENTE}/consultaresultado/help/index.html
  2- https://ecf.dgii.gov.do/{AMBIENTE}/consultaestado/help/index.html
</pre>


                        </v-col>


                      </v-row>
                    </v-col>
                    <!-- FINcuerpo FACTURACION ELETRONICA -->

                  </v-card>

                </v-col>
                <!-- fn Facturacion Electronica -->


                <v-form ref="formFVenta" v-model="valid" lazy-validation @submit.prevent="">
                  <!-- row 1 -->
                  <v-row>
                    <v-col cols="12" md="2" sm="2">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                              v-model="UtilFacturaVentas.fecha"
                              :rules="[$rules.required]"
                              dense
                              label="Fecha"
                              outlined
                              placeholder=" "
                              style="font-size: 12px"
                              type="date"
                              v-on="on"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 16px"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Se muestra la fecha de la factura de venta.</span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12" md="3" sm="3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-combobox
                              id="ImputColorDisable"
                              v-model="UtilFacturaVentas.documentoFactura"
                              :items="RDocumento"
                              :rules="[$rules.required]"
                              autocomplete="off"
                              dense
                              disabled
                              item-text="descripcion"
                              label="Documentos:"
                              outlined
                              style="font-size: 13px"
                              @blur="SelctCbDocumento"
                              @focus="cargarDocumento"
                              v-on="on"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-book" style="font-size: 18px"></i>
                            </template>
                          </v-combobox>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Se muestra el documento de la factura de venta.</span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12" md="2" sm="2">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                              id="ImputColorDisable"
                              v-model.number="UtilFacturaVentas.facturasventaPK.secuencia"
                              :rules="[$rules.required]"
                              autocomplete="off"
                              dense
                              disabled
                              label="No.Factura:"
                              outlined
                              style="font-size: 13px"
                              v-on="on"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-hashtag" style="font-size: 18px"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Se muestra el número de la factura de venta.</span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12" md="3" sm="3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                              v-model="UtilFacturaVentas.ncf"
                              dense
                              label=" NCF:"
                              outlined
                              placeholder=" "
                              style="font-size: 13px"
                              v-on="on"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-barcode" style="font-size: 18px"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Se muestra el número de comprobante fiscal de la factura de venta.</span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12" md="2" sm="2">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                              v-model.number="UtilFacturaVentas.numerocierre"
                              :rules="[$rules.required]"
                              autocomplete="off"
                              dense
                              label="No.Cierre:"
                              outlined
                              style="font-size: 13px"
                              type="number"
                              v-on="on"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-hashtag" style="font-size: 18px"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Se muestra el número de cierre de caja en el cual se realizó la factura.</span>
                        </i>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <!-- row 1 -->

                  <v-row style="margin-top: -25px">
                    <!-- cols 1-1  disabled-->
                    <v-col cols="12" md="6" sm="6">
                      <v-row style="margin-top: -14px">
                        <v-col cols="12" md="11" sm="11">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-combobox
                                  id="formTecniInput"
                                  v-model="UtilFacturaVentas.cliente"
                                  :items="RCliente"
                                  :suffix="clientTel"
                                  autocomplete="off"
                                  dense
                                  hide-details
                                  item-text="nombre"
                                  label="cliente:"
                                  outlined
                                  style="font-size: 13px"
                                  @blur="SelctCbCliente"
                                  @change="ClienteSelect"
                                  @focus="cargarCliente"
                                  @keyup="CbFilcliente"
                                  v-on="on"
                              >
                                <template v-slot:prepend>
                                  <i class="fa fa-user-circle" style="font-size: 20px"></i>
                                </template>
                              </v-combobox>
                            </template>
                            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                              <span>Se muestra el cliente correspondiente a la factura de venta.</span>
                            </i>
                          </v-tooltip>
                        </v-col>

                        <v-col cols="12" md="1" sm="1">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                  :disabled="disableRecalBalClient"
                                  color="blue"
                                  dark
                                  fab
                                  x-small
                                  v-on="on"
                                  @click.prevent="recalcularBalanceCliente"
                              >
                                <i class="fa fa-retweet" style="font-size: 18px"></i>
                              </v-btn>
                            </template>
                            <span>Recalcular Balance cliente</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>

                      <div style="border: 1px solid #000000;">
                        <v-row>
                          <v-col cols="12" md="6" sm="6">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <VueAutonumeric
                                    v-model="UtilFacturaVentas.cobertura"
                                    dense
                                    label="Cobertura"
                                    outlined
                                    required
                                    v-on="on"
                                >
                                  <template v-slot:prepend>
                                    <i class="fa fa-dollar" style="font-size: 20px"></i>
                                  </template>
                                </VueAutonumeric>
                              </template>
                              <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                                <span>Se muestra la cobertura correspondiente a la factura.</span>
                              </i>
                            </v-tooltip>

                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="UtilFacturaVentas.medico"
                                    dense
                                    label="Medico"
                                    outlined
                                    required
                                    v-on="on"
                                >
                                  <template v-slot:prepend>
                                    <i class="fa fa-user-md" style="font-size: 20px"></i>
                                  </template>
                                </v-text-field>
                              </template>
                              <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                                <span>Se muestra el medico que realizo el procedimiento o la receta al paciente..</span>
                              </i>
                            </v-tooltip>
                        
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  v-model="UtilFacturaVentas.diascredito"
                                  dense
                                  label="Días de Crédito"
                                  outlined
                                  v-on="on"
                              >
                                <template v-slot:prepend>
                                  <i class="fa fa-credit-card" style="font-size: 20px"></i>
                                </template>
                              </v-text-field>
                            </template>
                            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                              <span>Se muestra los días de créditos asignado a la factura.</span>
                            </i>
                          </v-tooltip>

                          </v-col>

                          <v-col cols="12" md="6" sm="6">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="UtilFacturaVentas.autorizacion"
                                    dense
                                    label="Autorizacion"
                                    outlined
                                    required
                                    v-on="on"
                                >
                                  <template v-slot:prepend>
                                    <i aria-hidden="true" class="fa fa-hospital-o" style="font-size: 20px"></i>
                                  </template>
                                </v-text-field>
                              </template>
                              <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                                <span>
                                  Se muestra el número de la autorización especificado por la ARS para la cobertura.
                                </span>
                              </i>
                            </v-tooltip>

                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <VueAutonumeric
                                    v-model="UtilFacturaVentas.coberturaPendiente"
                                    dense
                                    label="Cob Pendiente"
                                    outlined
                                    required
                                    v-on="on"
                                >
                                  <template v-slot:prepend>
                                    <i class="fa fa-dollar" style="font-size: 20px"></i>
                                  </template>
                                </VueAutonumeric>
                              </template>
                              <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                                <span>
                                  Se muestra el valor pendiente que debe la ARS correspondiente a la cobertura
                                  establecida en la factura.
                                </span>
                              </i>
                            </v-tooltip>
                       
                            <v-switch
                          v-model="UtilFacturaVentas.enviada"
                          class="mt-0"
                          color="success"
                          hide-detail
                          label="Activo"
                      >
                        <template v-slot:label>
                          <strong v-if="UtilFacturaVentas.enviada == true" style="color: #000000; font-size: 13px">
                            enviada Ars: Si
                          </strong>
                          <strong v-if="UtilFacturaVentas.enviada == false" style="color: #000000; font-size: 13px">
                            enviada Ars: No
                          </strong>
                        </template>
                      </v-switch>
                       
                          </v-col>
                        </v-row>

                        <div style="margin-top: -13px">
                          
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <!-------------------------------------------------- Concepto -->
                              <v-textarea
                                  v-model="UtilFacturaVentas.comentario"
                                  autocomplete="off"
                                  dense
                                  label="Comentario"
                                  outlined
                                  rows="1"
                                  style="font-size: 13px"
                                  v-on="on"
                              >
                                <template v-slot:prepend>
                                  <i class="fa fa-commenting" style="font-size: 20px"></i>
                                </template>
                              </v-textarea>
                            </template>
                            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                              <span>
                                Se muestra el comentario que se especificó al momento de hacer la factura de venta.
                              </span>
                            </i>
                          </v-tooltip>
                        </div>
                      </div>
                    </v-col>

                    <!-- fn cols 1-1  -->

                    <!-- cols 1-2  -->
                    <v-col cols="12" md="6" sm="6" style="margin-top: -12px;">
                      <v-row>
                        <v-col cols="12" md="6" sm="6">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-combobox
                                  v-model="UtilFacturaVentas.tipocomprobante"
                                  :items="RComprobantes"
                                  dense
                                  hide-details
                                  item-text="descripcion"
                                  label="Tipos de Comprobante:"
                                  outlined
                                  required
                                  style="font-size: 13px"
                                  @blur="SelctCbTipoComprobante"
                                  @focus="cargarTipoComprobante"
                                  v-on="on"
                              >
                                <template v-slot:prepend>
                                  <i class="fa fa-tag" style="font-size: 20px"></i>
                                </template>
                              </v-combobox>
                            </template>
                            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                              <span>Se muestra el tipo de comprobante de la factura venta..</span>
                            </i>
                          </v-tooltip>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-combobox
                                  v-model="UtilFacturaVentas.sucursal"
                                  :items="RSucursal"
                                  :rules="[$rules.required]"
                                  autocomplete="off"
                                  dense
                                  hide-details
                                  item-text="descripcion"
                                  label="Succursal:"
                                  outlined
                                  style="font-size: 13px"
                                  @blur="SelctCbSucursal"
                                  @focus="cargarSucursal"
                                  v-on="on"
                              >
                                <template v-slot:prepend>
                                  <i class="fa fa-sitemap" style="font-size: 20px"></i>
                                </template>
                              </v-combobox>
                            </template>
                            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                              <span>Se muestra la sucursal en la cual se hizo la factura de venta.</span>
                            </i>
                          </v-tooltip>
                        </v-col>
                      </v-row>

                      <v-col class="pa-0 ma-0 py-0 my-0 " cols="12" md="12" sm="12">
                        <!------------------------------- vendedor -->
                        <v-combobox id="formdisabledInput" ref="RefTextFieldBuscaVendedor"
                                    v-model="UtilFacturaVentas.vendedor"
                                    :items="Rvendedor"
                                    autocomplete="off" class="pt-2 fontSize13" dense hide-details item-text="nombre"
                                    label="Vendedor:" outlined
                                    style="font-size: 13px;"
                                    @blur="SelctCbvendedor"
                                    @focus="CargarRvendedor">
                          <template v-slot:prepend>
                            <i class="fa fa-universal-access" style="font-size: 20px;"></i>
                          </template>
                          <!-- margin-top="50px"style="font-size: 14px;" -->
                          <template slot="item" slot-scope="item">
                            <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                            <v-col class="pa-0 ma-0 py-0 my-0" cols="12"
                                   md="12"
                                   sm="12" style="border: 1px solid #000000; font-size: 13px; ">
                              <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>NOMBRE:
                                {{ item.item.nombre }}</b></p>

                              <span class="pa-0 ma-0 py-0 my-0">
                            <span style="border: 1px dashed  #616161;"><b>TEL.: </b>{{ item.item.telefono }} </span>
                            <span style="border: 1px dashed  #616161;"><b>CED/RNC: </b> {{ item.item.cedrnc }}</span>
                          </span>
                              <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>DIRECCIÓN: </b>
                                {{ item.item.direccion }} </p>
                              <span v-if="item.item.hasOwnProperty('ars') && item.item.ars != null"
                                    style="border: 1px dashed  #616161;"><b> ARS
                              :{{ item.item.ars.nombre }}</b></span>
                              <span v-if="item.item.diascredito > 0" style="border: 1px dashed  #616161;"><b> TIPO: Cliente
                              Credito</b></span>
                              <span v-if="item.item.diascredito == 0" style="border: 1px dashed  #616161;"><b>TIPO: Cliente
                              Contado</b></span>
                            </v-col>

                          </template>

                        </v-combobox>
                        <!------------------------------- fn vendedor -->
                      </v-col>

                      <!-- sub row 1 -->
                      <v-row class="pt-2" no-gutters style=" border: 1px solid #000000">
                        <!-- fn xol 1  -->
                        <v-col cols="12" md="6" sm="6">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <!--  @input="keyupVBruto()" -->
                              <!-- <VueAutonumeric v-on="on" label="Valor Bruto:" dense outlined
 autocomplete="off"
  v-model.number="UtilFacturaVentas.valor"
  :rules="[$rules.Numericc]"
  style="font-size: 13px;"

  >
    <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-money"></i>
    </template>
  </VueAutonumeric> -->
                            </template>
                            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                              <span>Se muestra el valor de la factura antes de el descuento y otras deducciones.</span>
                            </i>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <VueAutonumeric
                                  v-model.number="UtilFacturaVentas.valorimpuesto"
                                  autocomplete="off"
                                  dense
                                  label="ITBIS:"
                                  outlined
                                  style="font-size: 13px"
                                  v-on="on"
                              >
                                <template v-slot:prepend>
                                  <i class="fa fa-ravelry" style="font-size: 20px"></i>
                                </template>
                              </VueAutonumeric>
                            </template>
                            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                              <span>Se muestra el valor de itbis correspondiente a la factura.</span>
                            </i>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <VueAutonumeric
                                  v-model.number="UtilFacturaVentas.totalOtroImpuesto"
                                  autocomplete="off"
                                  dense
                                  label="Otros Impuestos:"
                                  outlined
                                  style="font-size: 13px"
                                  v-on="on"
                              >
                                <template v-slot:prepend>
                                  <i class="fa fa-percent" style="font-size: 20px"></i>
                                </template>
                              </VueAutonumeric>
                            </template>
                            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                              <span>
                                Se muestra el valor de impuesto adicionales que corresponde a esa factura (Ej. Impuesto
                                selectivo al consumo).
                              </span>
                            </i>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <VueAutonumeric
                                  v-model.number="UtilFacturaVentas.pendiente"
                                  autocomplete="off"
                                  dense
                                  label="Pendiente:"
                                  outlined
                                  style="font-size: 13px"
                                  v-on="on"
                              >
                                <template v-slot:prepend>
                                  <i class="fa fa-usd" style="font-size: 20px"></i>
                                </template>
                              </VueAutonumeric>
                            </template>
                            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                              <span>Se muestra el valor pendientea esa factura.</span>
                            </i>
                          </v-tooltip>
                        </v-col>
                        <!-- fn xol 1  -->

                        <!--  xol 2  -->
                        <v-col cols="12" md="6" sm="6">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <VueAutonumeric
                                  v-model.number="UtilFacturaVentas.valordescuento"
                                  autocomplete="off"
                                  dense
                                  label="Descuento:"
                                  outlined
                                  style="font-size: 13px"
                                  v-on="on"
                              >
                                <template v-slot:prepend>
                                  <i class="fa fa-usd" style="font-size: 20px"></i>
                                </template>
                              </VueAutonumeric>
                            </template>
                            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                              <span>Se muestra el valor descontado a la factura.</span>
                            </i>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <VueAutonumeric
                                  v-model="UtilFacturaVentas.totalIsr"
                                  :rules="[$rules.porciento]"
                                  autocomplete="off"
                                  dense
                                  label="ISR:"
                                  outlined
                                  style="font-size: 13px"
                                  v-on="on"
                              >
                                <template v-slot:prepend>
                                  <i class="fa fa-list-alt" style="font-size: 20px"></i>
                                </template>
                              </VueAutonumeric>
                            </template>
                            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                              <span>
                                Se muestra el valor retenido del impuesto sobre la renta correspondiente en esa factura.
                              </span>
                            </i>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <VueAutonumeric
                                  v-model.number="UtilFacturaVentas.valor"
                                  :rules="[$rules.Numericc]"
                                  autocomplete="off"
                                  dense
                                  label="Valor:"
                                  outlined
                                  v-on="on"
                              >
                                <template v-slot:prepend>
                                  <i class="fa fa-money" style="font-size: 20px"></i>
                                </template>
                              </VueAutonumeric>
                            </template>
                            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                              <span>Se muestra el valor final de la factura.</span>
                            </i>
                          </v-tooltip>
                        </v-col>
                        <!-- fn xol 2  -->
                      </v-row>
                      <!-- sub row 1 -->

                      <v-switch
                          v-model="UtilFacturaVentas.activada"
                          class="mt-0"
                          color="success"
                          hide-detail
                          label="Activo"
                      >
                        <template v-slot:label>
                          <strong v-if="UtilFacturaVentas.activada == true" style="color: #000000; font-size: 13px">
                            Activo: Si
                          </strong>
                          <strong v-if="UtilFacturaVentas.activada == false" style="color: #000000; font-size: 13px">
                            Activo: No
                          </strong>
                        </template>
                      </v-switch>
                    </v-col>
                    <!-- fn cols 1-2  -->
                  </v-row>
                  <!-- fn row 2 -->

                  <!-- row 3 -->
                  <v-row style="margin-top: -10px">
                    <!------------------------- columna 1 -->
                    <v-col cols="12" md="3" sm="3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                              v-model.number="UtilFacturaVentas.efectivo"
                              :disabled="disableAll"
                              :rules="[$rules.Numericc]"
                              autocomplete="off"
                              dense
                              label="Efectivo:"
                              outlined
                              style="font-size: 13px"
                              @input="sumaValor"
                              v-on="on"
                              v-on:input="getCrear"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Se muestra el valor pagado, si el pago de la factura fue en efectivo.</span>
                        </i>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                              v-model.number="UtilFacturaVentas.cupones"
                              :disabled="disableAll"
                              :rules="[$rules.Numericc]"
                              autocomplete="off"
                              dense
                              label="cupon:"
                              outlined
                              style="font-size: 13px"
                              @input="sumaValor"
                              v-on="on"
                              v-on:input="getCrear"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Se muestra el valor pagado, si el pago de la factura fue mediante un cupón.</span>
                        </i>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                              v-model.number="UtilFacturaVentas.cxc"
                              :disabled="disableAll"
                              :rules="[$rules.Numericc]"
                              autocomplete="off"
                              dense
                              label="CxC:"
                              outlined
                              style="font-size: 13px"
                              @input="sumaValor"
                              v-on="on"
                              v-on:input="getCrear"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>
                            Se muestra el valor pagado, si el pago de la factura fue a cuenta por cobrar al cliente.
                          </span>
                        </i>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                              v-model.number="UtilFacturaVentas.transferencia"
                              :disabled="disableAll"
                              :rules="[$rules.Numericc]"
                              autocomplete="off"
                              dense
                              label="Transferencia:"
                              outlined
                              style="font-size: 13px"
                              @input="sumaValor"
                              v-on="on"
                              v-on:input="getCrear"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>
                            Se muestra el valor pagado, si el pago de la factura fue mediante transferencia.
                          </span>
                        </i>
                      </v-tooltip>

                      <!-- <v-tooltip top>
<template v-slot:activator="{ on }">

<VueAutonumeric v-on="on" label="Conduce:" dense outlined
 autocomplete="off"
  v-model.number="UtilFacturaVentas.tarjeta"
  :rules="[$rules.required]"
  @input="sumaValor"
  :disabled="disableAll"
   v-on:input="getCrear"
   style="font-size: 13px;"
  >
    <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-money"></i>
    </template>
  </VueAutonumeric>

 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Se muestra la Sucursal en la cual se hizo el  la factura.</span>
    </i>   
  </v-tooltip> -->
                    </v-col>

                    <!------------------------- columna 2 -->

                    <v-col cols="12" md="3" sm="3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                              v-model.number="UtilFacturaVentas.cheques"
                              :disabled="disableAll"
                              :rules="[$rules.Numericc]"
                              autocomplete="off"
                              dense
                              label="Valor cheque:"
                              outlined
                              style="font-size: 13px"
                              @input="sumaValor"
                              v-on="on"
                              v-on:input="getCrear"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Se muestra el valor pagado, si el pago de la factura fue en cheque.</span>
                        </i>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                              v-model.number="UtilFacturaVentas.valorasignacion"
                              :disabled="disableAll"
                              :rules="[$rules.Numericc]"
                              autocomplete="off"
                              dense
                              label="Asignación:"
                              outlined
                              style="font-size: 13px"
                              @input="sumaValor"
                              v-on="on"
                              v-on:input="getCrear"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>
                            Se muestra el valor pagado, si el pago de la factura fue mediante una asignación a un
                            cliente.
                          </span>
                        </i>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                              v-model.number="UtilFacturaVentas.valorTraspaso"
                              :disabled="disableAll"
                              :rules="[$rules.Numericc]"
                              autocomplete="off"
                              dense
                              label="Traspaso:"
                              outlined
                              style="font-size: 13px"
                              @input="sumaValor"
                              v-on="on"
                              v-on:input="getCrear"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>
                            Se muestra el valor pagado, si el pago de la factura fue mediante establecer el registro de
                            transferir una diferencia de un dispensador de combustible a otro.
                          </span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <!------------------------- columna 3 -->
                    <v-col cols="12" md="3" sm="3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                              v-model.number="UtilFacturaVentas.tarjeta"
                              :disabled="disableAll"
                              :rules="[$rules.Numericc]"
                              autocomplete="off"
                              dense
                              label="Valor Tarjeta:"
                              outlined
                              style="font-size: 13px"
                              @input="sumaValor"
                              v-on="on"
                              v-on:input="getCrear"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Se muestra el valor pagado, si el pago de la factura fue en tarjeta.</span>
                        </i>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                              v-model.number="UtilFacturaVentas.puntos"
                              :disabled="disableAll"
                              :rules="[$rules.Numericc]"
                              autocomplete="off"
                              dense
                              label="Puntos:"
                              outlined
                              style="font-size: 13px"
                              @input="sumaValor"
                              v-on="on"
                              v-on:input="getCrear"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>
                            Se muestra el valor pagado, si el pago de la factura fue mediante puntos ganados por el
                            cliente.
                          </span>
                        </i>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                              v-model.number="UtilFacturaVentas.valordonacion"
                              :disabled="disableAll"
                              :rules="[$rules.Numericc]"
                              autocomplete="off"
                              dense
                              label="Donación:"
                              outlined
                              style="font-size: 13px"
                              @input="sumaValor"
                              v-on="on"
                              v-on:input="getCrear"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>
                            Se muestra el valor pagado, si el pago de la factura fue mediante una donación a un cliente.
                          </span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12" md="3" sm="3">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                              v-model.number="UtilFacturaVentas.valorNc"
                              :disabled="disableAll"
                              :rules="[$rules.Numericc]"
                              autocomplete="off"
                              dense
                              label="NCR:"
                              outlined
                              style="font-size: 13px"
                              @input="sumaValor"
                              v-on="on"
                              v-on:input="getCrear"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>Se muestra el valor pagado, si el pago de la factura fue con una nota de crédito.</span>
                        </i>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                              v-model.number="UtilFacturaVentas.valorbonogas"
                              :disabled="disableAll"
                              :rules="[$rules.Numericc]"
                              autocomplete="off"
                              dense
                              label="Bono Gas:"
                              outlined
                              style="font-size: 13px"
                              @input="sumaValor"
                              v-on="on"
                              v-on:input="getCrear"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>
                            Se muestra el valor pagado, si el pago de la factura fue mediante un bono de gas dado a un
                            cliente.
                          </span>
                        </i>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <VueAutonumeric
                              v-model.number="UtilFacturaVentas.valorPruebaMetro"
                              :disabled="disableAll"
                              :rules="[$rules.Numericc]"
                              autocomplete="off"
                              dense
                              label="Prueba Metro:"
                              outlined
                              style="font-size: 13px"
                              @input="sumaValor"
                              v-on="on"
                              v-on:input="getCrear"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-money" style="font-size: 20px"></i>
                            </template>
                          </VueAutonumeric>
                        </template>
                        <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                          <span>
                            Se muestra el valor pagado, si el pago de la factura fue mediante establecer el registro de
                            la perdida de combustible de los dispensadores.
                          </span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <!-- <v-col cols="12" md="4" sm="4"> 

<v-tooltip top>
<template v-slot:activator="{ on }"> 

<VueAutonumeric   v-on="on" 

 label="Valor:" dense outlined
 autocomplete="off"
  v-model.number="UtilFacturaVentas.valor"
  :rules="[$rules.required]"
  style="font-size: 13px;"
  
  >
    <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-money"></i>
    </template>
  </VueAutonumeric>

 </template>
<i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Se muestra el valor del recibo.</span>
    </i>   
  </v-tooltip>


</v-col> -->
                  </v-row>

                  <!-- fin row 3 -->

                  <v-row></v-row>
                </v-form>

                <v-col cols="12" md="12" sm="12">
                  <!-- @click:row="datostabla" -->

                  <v-card>
                    <v-toolbar color="indigo" dense flat>
                      <v-card-actions v-if="windowSize.width > 600">
                        <v-tooltip v-if="false" top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                                :disabled="UtilFacturaVentas.facturasventaPK.secuencia <= 0"
                                color="green"
                                rounded
                                v-on="on"
                                @click.prevent="dialogAddProducto = !dialogAddProducto"
                            >
                              <i class="fa fa-plus-square" style="font-size: 20px"></i>
                              <!-- fab x-small dark  -->
                              Agregar
                            </v-btn>
                          </template>
                          <span>Agregar Productos</span>
                        </v-tooltip>

                        <!-- <v-btn-toggle rounded dense  ></v-btn-toggle> facturasVentaList.length>0     -->
                        <v-tooltip v-if="false" top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                                :disabled="disabledRestFacVenta"
                                color="blue lighten-3"
                                rounded
                                v-on="on"
                                @click.prevent="NotifrestaurarFacVenta"
                            >
                              <i class="fa fa-retweet" style="font-size: 20px"></i>
                              <!-- fab x-small dark  -->
                              Restaurar
                            </v-btn>
                          </template>
                          <span>Restaurar detalle</span>
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                                :disabled="GenerarContloading"
                                color="teal"
                                rounded
                                v-on="on"
                                @click.prevent="GenerarContabilidad"
                            >
                              <i class="fa fa-retweet" style="font-size: 20px"></i>
                              <!-- fab x-small dark  -->
                              Generar contabilidad
                            </v-btn>
                          </template>
                          <span>Generar contabilidad</span>
                        </v-tooltip>
                      </v-card-actions>

                      <v-spacer></v-spacer>
                      <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
                    </v-toolbar>

                    <div style="border: 1px solid #000000">
                      <v-data-table
                          id="TbBord"
                          :footer-props="arrayPropiedases"
                          :headers="[
                          {
                            text: 'Cod.Producto',
                            sortable: false,
                            value: 'productos.codigo',
                            width: 90,
                            class: ['no-gutters black--text'],
                          },
                          {
                            text: 'Producto',
                            sortable: false,
                            value: 'descripcion',
                            width: 329,
                            class: ['no-gutters black--text'],
                          },
                          {
                            text: 'Cant.Pen',
                            sortable: false,
                            value: 'cantidadPendiente',
                            width: 100,
                            class: ['no-gutters black--text'],
                          },
                          {
                            text: 'Cant',
                            sortable: false,
                            value: 'cantidad',
                            width: 100,
                            class: ['no-gutters black--text'],
                          },
                          { text: 'Precio (Sin Impuesto)', sortable: false, value: 'precio', width: 160 },
                          {
                            text: 'Impuesto',
                            sortable: false,
                            value: 'valorimpuesto',
                            width: 130,
                            class: ['no-gutters black--text'],
                          },
                          {
                            text: 'Descuento',
                            sortable: false,
                            value: 'valorpordesc',
                            width: 150,
                            class: ['no-gutters black--text'],
                          },
                          {
                            text: 'Des',
                            sortable: false,
                            align: 'center',
                            value: 'descuentoPorciento',
                            width: 120,
                            class: ['no-gutters black--text'],
                          },
                          {
                            text: 'Valor',
                            sortable: false,
                            value: 'valorr',
                            width: 150,
                            class: ['no-gutters black--text'],
                          },
                          {
                            text: 'Acción',
                            sortable: false,
                            align: 'center',
                            value: 'action',
                            width: 'auto',
                            width: 105,
                            class: ['no-gutters black--text'],
                          },
                        ]"
                          :items="facturasVentaList"
                          :items-per-page="15"
                          :search="search"
                          class="elevation-1"
                          dense
                      >
                        <!-- style="margin-right:-80px;" -->
                        <template v-slot:item.action="{ item }">
                          <!-- { text: 'Acción', sortable: false, value: 'action', width:'auto' }, -->
                          <v-btn
                              id="formdisabledInput"
                              color="red darken-3"
                              disabled
                              fab
                              x-small
                              @click.prevent="deleProducto(item)"
                          >
                            <i class="fa fa-trash-o" style="font-size: 20px"></i>
                          </v-btn>
                          <!-- <v-btn fab @click.prevent="deleFact(item)" x-small color="red darken-3"><i style="font-size: 20px;" class="fa fa-trash-o"></i></v-btn> -->
                        </template>

                        <template v-slot:item.descripcion="props">
                          <!-- <span style="font-size:13px;" >{{ props.item.descripcion }}</span> -->

                          <v-text-field
                              id="formdisabledInput"
                              v-model="props.item.descripcion"
                              autocomplete="off"
                              dense
                              disabled
                              hide-details
                              label=""
                              outlined
                              style="font-size: 13px"
                          ></v-text-field>
                        </template>

                        <template v-slot:item.valorr="props">
                          <VueAutonumeric
                              id="formTecniInput"
                              v-model="props.item.valor"
                              autocomplete="off"
                              dense
                              disabled
                              hide-details
                              label=""
                              outlined
                              style="font-size: 13px"
                          ></VueAutonumeric>
                        </template>

                        <template v-slot:item.cantidadPendiente="props">
                          <v-text-field
                              id="formdisabledInput"
                              v-model.number="props.item.cantidadPendiente"
                              autocomplete="off"
                              dense
                              disabled
                              hide-details
                              label=""
                              outlined
                              style="font-size: 13px"
                              @blur="BlurVerifCantPenCant(props.item)"
                              @keyup="KeyUpCantidad"
                              v-on:keyup="CalcularFact"
                          ></v-text-field>
                          <!-- v-on:keyup="CalcularDenominacion" -->
                        </template>

                        <template v-slot:item.cantidad="props">
                          <v-text-field
                              id="formdisabledInput"
                              v-model.number="props.item.cantidad"
                              autocomplete="off"
                              dense
                              disabled
                              hide-details
                              label=""
                              outlined
                              style="font-size: 13px"
                              @blur="BlurVerifCantPenCant(props.item)"
                              @keyup="KeyUpCantidad"
                              v-on:keyup="CalcularFact"
                          ></v-text-field>
                          <!-- v-on:keyup="CalcularDenominacion" -->
                        </template>

                        <template v-slot:item.precio="props">
                          <VueAutonumeric
                              id="formdisabledInput"
                              v-model="props.item.precio"
                              autocomplete="off"
                              dense
                              disabled
                              hide-details
                              label=""
                              outlined
                              style="font-size: 13px"
                              @input="CalcularFact"
                          ></VueAutonumeric>
                        </template>

                        <template v-slot:item.valorimpuesto="props">
                          <span v-if="props.item.valorimpuesto == null" style="display: none">
                            {{ (props.item.valorimpuesto = 0) }}
                          </span>

                          <VueAutonumeric
                              id="formdisabledInput"
                              v-model="props.item.valorimpuesto"
                              autocomplete="off"
                              dense
                              disabled
                              hide-details
                              label=""
                              outlined
                              style="font-size: 13px"
                              @input="CalcularFact"
                          ></VueAutonumeric>
                        </template>

                        <template v-slot:item.valorpordesc="props">
                          <VueAutonumeric
                              v-if="props.item.descuentoPorciento == false"
                              id="formdisabledInput"
                              v-model="props.item.valordescuento"
                              autocomplete="off"
                              dense
                              disabled
                              hide-details
                              label=""
                              outlined
                              style="font-size: 13px"
                              @input="CalcularFact"
                          ></VueAutonumeric>

                          <VueAutonumeric
                              v-if="props.item.descuentoPorciento == true"
                              id="formdisabledInput"
                              v-model="props.item.descuento"
                              autocomplete="off"
                              dense
                              disabled
                              hide-details
                              label=""
                              outlined
                              style="font-size: 13px"
                              @input="CalcularFact"
                          ></VueAutonumeric>
                        </template>

                        <template v-slot:item.descuentoPorciento="props">
                          <v-switch
                              id="formdisabledInput"
                              v-model="props.item.descuentoPorciento"
                              class=""
                              color="success"
                              dense
                              disabled
                              hide-details
                              label="Activo"
                              @change="ChangeDescPorc(props.item)"
                          >
                            <template v-slot:label>
                              <strong
                                  v-if="props.item.descuentoPorciento == true"
                                  style="color: #000000; font-size: 20px"
                              >
                                %
                              </strong>
                              <strong
                                  v-if="props.item.descuentoPorciento == false"
                                  style="color: #000000; font-size: 20px"
                              >
                                $
                              </strong>
                            </template>
                          </v-switch>
                        </template>

                        <template v-slot:item.valor="props">
                          <span>{{ currencyFormatter(props.item.valor) }}</span>
                        </template>

                        <template v-if="windowSize.width > 600" v-slot:body.append>
                          <tr>
                            <td class="border-top-bottom"><strong></strong></td>
                            <td class="border-top-bottom"><strong></strong></td>
                            <td class="border-top-bottom">
                              <strong class="d-flex justify-end" style="font-size: 11px; color: #00838f">Total:</strong>
                            </td>
                            <td class="border-total">
                              <strong class="d-flex justify-center" style="font-size: 15px; color: #00838f">
                                {{ Totales.Cant }}
                              </strong>
                            </td>
                            <td class="border-total">
                              <strong class="d-flex justify-center" style="font-size: 15px; color: #00838f">
                                {{ currencyFormatter(Totales.Precio) }}
                              </strong>
                            </td>
                            <td class="border-total">
                              <strong class="d-flex justify-center" style="font-size: 15px; color: #00838f">
                                {{ currencyFormatter(Totales.Impuresto) }}
                              </strong>
                            </td>
                            <td class="border-total">
                              <strong class="d-flex justify-center" style="font-size: 15px; color: #00838f">
                                {{ currencyFormatter(Totales.Descuento) }}
                              </strong>
                            </td>
                            <td class="border-top-bottom"><strong></strong></td>
                            <td class="border-total">
                              <strong class="d-flex justify-center" style="font-size: 15px; color: #00838f">
                                {{ currencyFormatter(Totales.Valor) }}
                              </strong>
                            </td>
                            <td class="border-top-bottom"><strong></strong></td>
                          </tr>
                        </template>

                        <template v-if="windowSize.width <= 600" v-slot:footer>
                          <v-list-item class="white--text" style="font-size: 70%">
                            <v-list-item-content>
                              <span>Total de horas:{{ currencyFormatter(Totales.Precio) }}</span>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-data-table>
                    </div>
                  </v-card>

                  <hr/>
                  <CuentasContables
                      :RLisCuenta="RLisCuenta"
                      :Total="TotalCuenta"
                      @CuentasContables="CCuentasContables"
                  />
                </v-col>
              </div>
            </v-card>
          </div>
        </v-app>
      </td>
      <!-- fn contenido central ------------------------------------------------------------------------------------->
      <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">
        <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
        >
          <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
        </div>
      </td>
      <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
        v-model="acti_tb_data"
        label="myAlert"
        max-height="100%"
        max-width="100%"
        persistent
        transition="fab-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
                :footer-props="arrayPropiedases"
                :headers="slotHtabla"
                :items="list"
                :search="search"
                dense
                @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog v-model="Elim_notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr/>

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr/>
        <v-card-actions>
          <v-btn small @click.prevent="eliminar(), (Elim_notif.estado = !Elim_notif.estado)">
            <i class="fa fa-check" style="font-size: 20px"></i>
            Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i>
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog v-model="notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr/>

        <v-card-text>
          <h5>{{ notif.nombre }}</h5>
        </v-card-text>

        <hr/>
        <v-card-actions>
          <v-btn
              v-if="(notif.Exec = 'ResFacVent')"
              small
              @click.prevent="restaurarFacVenta(), (notif.estado = !notif.estado)"
          >
            <i class="fa fa-check" style="font-size: 20px"></i>
            Si
          </v-btn>

          <v-btn small @click.prevent="notif.estado = !notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i>
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
        v-model="aalert.estado"
        :color="aalert.color"
        :timeout="120000"
        :vertical="true"
        style="margin-top: 20%"
        top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialogReporte" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="grey darken-2" dark>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-toolbar-title v-on="on">Imprecion de reporte</v-toolbar-title>
            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
              <span>Imprecion:</span>
              Vista e Imprecion del reporte
            </i>
          </v-tooltip>

          <!-- <v-toolbar-title>Ordenes De Compras sugeridas</v-toolbar-title> -->

          <v-spacer></v-spacer>

          <v-btn color="grey darken-4" fab small @click="NewReporte">
            <i class="fa fa-close" style="font-size: 20px; color: white"></i>
          </v-btn>
        </v-toolbar>

        <v-list subheader three-line>
          <pdf-app :config="config" :pdf="pdf" style="height: 100vh"></pdf-app>
        </v-list>
      </v-card>
    </v-dialog>

    <!-- ------------------------------------------------------ Modal- nueva Produecto-->
    <v-dialog
        v-model="dialogAddProducto"
        label="Modal agregar producto"
        max-height="80%"
        max-width="90%"
        persistent
        transition="fab-transition"
    >
      <AgregarProducto @EmitAgregarProducto="RecAgregarProducto"/>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- nueva producto-->

    <v-dialog v-model="Reparaloading" persistent width="300">
      <v-card color="grey darken-2" dark>
        <v-card-text>
          Espere...
          <v-progress-linear class="mb-0" color="white" indeterminate></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
    <!---------------------  Panel Menu Opcion Botones style="max-height:300px;" ------------------------------->
    <div v-show="false" class="overflow-x-auto">
      <!-- columna  ---------------------->
      <PvDgiiFacturacionEletronica ref="RefPvDgiiFacturacionEletronica"/>
    </div>

  </div>
</template>

<script>
import AgregarProducto from "@/UtilidadComponents/AgregarProducto.vue"
import {EventBus} from "../event-bus"
import BarraBusqueda2 from "../components/BarraBusquedaDinam"
import VueAutonumeric from "../components/AutoNumericNuevo"
import CuentasContables from "@/UtilidadComponents/CuentasContables"
import ContenidoBase from "../components/ContenidoBase"
import {currencyFormatter, fechaNueva, FormatoFecha, getHoraActual, HoraFormatter} from "@/js/Funciones.js"
import PvDgiiFacturacionEletronica from "@/PuntodeVenta/UtilidadComponents/PvDgiiFacturacionEletronica.vue"

export default {
  components: {
    BarraBusqueda2,
    VueAutonumeric,
    CuentasContables,
    PdfApp: window["pdf-viewer"],
    AgregarProducto,
    ContenidoBase,
    PvDgiiFacturacionEletronica,
  },

  created() {
    var json = {
      titulo: "Utilitario Factura Ventas",
      descripcion: "Utilitario Factura Ventas",
      save: true,
      eliminar: false,
      anular: false,
      nuevo: true,
      imprimir: false,
      btnBarraDi: false,
      recalcular: true,

      accion: [
        "UtilitarioFactVentNew",
        "UtilitarioFactVentSave",
        "UtilitarioFactVentRemove",
        "UtilitarioFactVentAnular",
        "UtilitarioFactVentPrintList",
        "UtilitarioFactVentVercuenta",
        "UtilitarioFactVentCorreo",
        "UtilitarioFactVentRecalcular",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("UtilitarioFactVentNew", this.newwnuevo)
    EventBus.$on("UtilitarioFactVentSave", this.save)
    EventBus.$on("UtilitarioFactVentRemove", this.remove)
    EventBus.$on("UtilitarioFactVentAnular", this.remove)
    EventBus.$on("UtilitarioFactVentPrintList", this.imprimirList)
    EventBus.$on("emitUtilitarioFactVent", this.datostabla)
    EventBus.$on("UtilitarioFactVentRecalcular", this.Recalcular)
    // this.cargarTodo();
    console.log("viendo-->", this.getHoraActual())
    EventBus.$on("onResize", this.onResize)
  },

  data: () => ({
    arrayPropiedases: {
      "items-per-page-options": [10, 15, 20, 50],
      "items-per-page-text": "Cantidad de Registros Por Paginas",
      showFirstLastPage: false,
    },
    contabilidad: null,
    selected: [],
    config: {findbar: false},
    pdf: "",

    ListaTiposClientes: [],
    listFactVent: [],
    facturasVentaList: [],
    windowSize: {width: "auto", height: "auto"},

    Reparaloading: false,

    disableAll: false,
    dialogReporte: false,
    dialogAddProducto: false,
    disabledRestFacVenta: true,
    disableRecalBalClient: false,
    disableInp: false,

    RComprobantes: [],
    RSucursal: [],
    Ralmacen: [],
    Rpropietario: [],
    RSucursal: [],
    RCaja: [],
    RCliente: [],
    RDocumento: [],
    Rvendedor: [],
    RVendedor: [],
    RLisCuenta: [],
    Ralmacen: [],
    RfilVendedor: "nombre",
    clientTel: "",

    TotalRegistros: 1,
    resertPagi: true,
    paginator: {
      itemsPerPage: 15,
      pageStart: 1,
      page: 1,
      pageStop: 15,
      pageCount: 10,
      itemsLength: 5,
    },

    busquedaFacVent: {
      cliente: null,
      fechaInicial: fechaNueva(),
      fechaFinal: fechaNueva(),
      NoFactura: 0,
      documento: null,
      ncf: null,
      opcion: 0,
      buscarTrackId: "",
    },

    ObjAnteFac: null,
    GenerarContloading: false,
    UtilFacturaVentas: {
      //fecha:new Date().toISOString().substr(0,10),
      fecha: "",
      documentoFactura: null,

      facturasventaPK: {
        secuencia: 0,
      },
      ncf: "",
      cliente: null,
      tipocomprobante: null,
      sucursal: null,

      cobertura: null,
      autorizacion: null,
      medico: null,
      coberturaPendiente: null,
      diascredito: 0,
      comentario: "",

      valordescuento: 0,
      valorimpuesto: 0,
      totalIsr: 0,
      totalOtroImpuesto: 0,
      valor: 0,

      efectivo: 0,
      cheques: 0,
      tarjeta: 0,
      transferencia: 0,
      valorNc: 0,

      cupones: 0,
      valorasignacion: 0,
      puntos: 0,
      valorbonogas: 0,
      cxc: 0,

      pendiente: 0,
      valordonacion: 0,
      valorPruebaMetro: 0,
      valorTraspaso: 0,
      valorPruebaMetro: 0,
      activada: true,
      enviada:false
    },

    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: true,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },

    Totales: {
      Cant: 0,
      Precio: 0,
      Impuresto: 0,
      Descuento: 0,
      Valor: 0,
    },

    TotalCuenta: {
      credito: 0,
      debito: 0,
    },

    RTipo: [
      {codigo: 1, descripcion: "Valor"},
      {codigo: 2, descripcion: "Porcentaje"},
    ],

    RPagosAnticipado: [
      {p: "Arros", e: "5", c: "200"},
      {p: "aguacate", e: "15", c: "100"},
      {p: "guineo", e: "25", c: "50"},
      {p: "papa", e: "50", c: "80"},
      {p: "pera", e: "60", c: "90"},
    ],

    text: "",
    valid: true,
    BarraPrimariaAbrir: false,
    BarraSecundariaAprir: false,

    headers: [{text: "Tipo Clientes", value: "descripcion"}],

    slotlist: [
      {dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:"},
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:",
      },
      {dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo"},
    ],

    slotHtabla: [
      {text: "Código", value: "codigo"},
      {text: "Descripcion", value: "descripcion"},
    ],

    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?",
    },

    notif: {
      estado: false,
      nombre: "",
      Exec: "",
    },

    aalert: {
      estado: false,
      color: null,
    },
  }),

  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter,
    FormatoFecha,
    HoraFormatter,
    fechaNueva,
    getHoraActual,
    onResize(e) {
      // this.windowSize=e
    },

    abrirTabla() {
      this.BarraPrimariaAbrir = !this.BarraPrimariaAbrir
    },
    async cargarTodo() {
    },

    obtenerDatoSelect(e) {
      this.datostabla(e.item)
    },

    datostabla(e) {
      var eftc = JSON.parse(JSON.stringify(e))

      this.selected = []
      this.selected.push(JSON.parse(JSON.stringify(e)))

      if (eftc.valordescuento == null) {
        e.valordescuento = 0
      }
      if (eftc.valorimpuesto == null) {
        e.valorimpuesto = 0
      }

      if (eftc.totalIsr == null) {
        e.totalIsr = 0
      }
      if (eftc.totalOtroImpuesto == null) {
        e.totalOtroImpuesto = 0
      }
      if (eftc.valor == null) {
        e.valor = 0
      }
      if (eftc.efectivo == null) {
        e.efectivo = 0
      }
      if (eftc.cheques == null) {
        e.cheques = 0
      }
      if (eftc.tarjeta == null) {
        e.tarjeta = 0
      }
      if (eftc.transferencia == null) {
        eftc.transferencia = 0
      }
      if (eftc.valorNc == null) {
        e.valorNc = 0
      }
      if (eftc.cupones == null) {
        e.cupones = 0
      }
      if (eftc.valorasignacion == null) {
        e.valorasignacion = 0
      }

      if (eftc.puntos == null) {
        e.puntos = 0
      }
      if (eftc.valorbonogas == null) {
        e.valorbonogas = 0
      }
      if (eftc.cxc == null) {
        e.cxc = 0
      }
      if (eftc.valordonacion == null) {
        e.valordonacion = 0
      }

      if (eftc.valorPruebaMetro == null) {
        e.valorPruebaMetro = 0
      }
      if (eftc.valorTraspaso == null) {
        e.valorTraspaso = 0
      }
      if (eftc.valorPruebaMetro == null) {
        e.valorPruebaMetro = 0
      }

      eftc.fecha = new Date(e.fecha).toISOString().substr(0, 10) //this.acti_tb_data=false

      eftc.facturasventaDetalleList.forEach((element) => {
        if (element.hasOwnProperty("valordescuento") && element.valordescuento != null) {
          if (element.valordescuento > 0) {
            element.descuentoPorciento = false
          } else {
            element.descuentoPorciento = true
          }
        } else {
          element.descuentoPorciento = true
          element.valordescuento = 0
        }

        if (element.hasOwnProperty("descuento") && element.descuento != null) {
          if (element.descuento > 0) {
            element.descuentoPorciento = true
          } else {
            element.descuentoPorciento = false
          }
        } else {
          element.descuentoPorciento = false
          element.descuento = 0
        }

        if (element.cantidadPendiente != element.cantidad) {
          this.alerta("Aparentemente  esta factura tiene una devolución (Revise)", "error")
        }
      })

      this.facturasVentaList = JSON.parse(JSON.stringify(eftc.facturasventaDetalleList))

      delete eftc["facturasventaDetalleList"]
      ;(this.contabilidad = null), (this.RLisCuenta = [])

      var obj = {
        UtilFacturaVentas: JSON.parse(JSON.stringify(e)),
        contabilidad: null,
      }

      if(!eftc.hasOwnProperty('enviada') || eftc.hasOwnProperty('enviada')&& eftc.enviada==null){
        eftc.enviada=false
      }

      if(!eftc.hasOwnProperty('cobertura') || eftc.hasOwnProperty('cobertura')&& eftc.cobertura==null){
        eftc.cobertura=0
      }

     if(!eftc.hasOwnProperty('coberturaPendiente') || eftc.hasOwnProperty('coberturaPendiente')&& eftc.coberturaPendiente==null){
        eftc.coberturaPendiente=0
      }


      this.UtilFacturaVentas = eftc



      /*this.$axios.post(this.$hostname+this.$hName+'/services/utilitarioContabilidad/BuscarContabilidad',{
usuario:JSON.parse(JSON.stringify(this.$user)),
documento: e.facturasventaPK.documento,
secuencia: e.facturasventaPK.secuencia,
operacion: e.documentoFactura.operacion.codigo
})
.then(res=>{
if(res.data.toString().length >0){
this.contabilidad=res.data, 
this.RLisCuenta=JSON.parse(JSON.stringify(res.data.contabilidadDetalleList)),
this.calcularTotalcuenta(res.data.contabilidadDetalleList),
obj.contabilidad=JSON.parse(JSON.stringify(this.contabilidad)),
this.ObjAnteFac=JSON.stringify(obj) 
}
})*/

      this.$axios
          .get(
              this.$hostname +
              this.$hName +
              "/contabilidad/findContabilidad/" +
              e.facturasventaPK.documento +
              "/" +
              e.facturasventaPK.secuencia +
              "/" +
              e.documentoFactura.operacion.codigo,
              {headers: this.$store.getters.GetheadersAxios},
          )
          .then((res) => {
            if (res.data.toString().length > 0) {
              ;(this.contabilidad = res.data),
                  (this.RLisCuenta = JSON.parse(JSON.stringify(res.data.contabilidadDetalleList))),
                  this.calcularTotalcuenta(res.data.contabilidadDetalleList),
                  (obj.contabilidad = JSON.parse(JSON.stringify(this.contabilidad))),
                  (this.ObjAnteFac = JSON.stringify(obj))
            }
          })
          .catch((error) => {
            this.alertaNotf("Dato no guardado" + error, "error")
          })

      setTimeout(this.CalcularFact, 3)
    },
    save() {
      /*var FACTURA =JSON.parse(JSON.stringify(this.UtilFacturaVentas));
    console.log('OBJ-FACTURA-->',FACTURA)
    console.log('OBJ-LISTA-SELET-->',this.selected[0])*/
      EventBus.$emit("loading", true)
      if (this.UtilFacturaVentas.cxc > 0) {
        var doc = this.UtilFacturaVentas.facturasventaPK.documento
        var sec = this.UtilFacturaVentas.facturasventaPK.secuencia

        this.$axios
            .get(this.$hostname + this.$hName + `/utilitarioFacturaVentas/verificarReciboIngFactura/${sec}/${doc}`, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              if (res.data == true) {
                this.alerta("Esta factura posee pagos aplicado y no se puede modificar ", "error")
              } else {
                this.saveCont()
              }
            })
            .catch((error) => {
              this.alerta("Los campos en rojo son requeridos", "error")
            })
      } else {
        this.saveCont()
      }
    },

    saveCont() {
      // console.log('savvee')
      // console.log(JSON.parse(sessionStorage.getItem("NombreImprementador")))

      if (this.$refs.formFVenta.validate()) {
        if (this.TotalCuenta.credito != this.TotalCuenta.debito) {
          //this.acti_Modal_cuenta = true
          this.alerta("El total de debito y credito no coincide en el asiento contable", "error")
          return 0
        }

        /*var jsn={
UtilFacturaVentas:JSON.parse(JSON.stringify(this.UtilFacturaVentas)),
facturasVentaList:JSON.parse(JSON.stringify(this.facturasVentaList)),
contabilidadList:JSON.parse(JSON.stringify(this.RLisCuenta)),
ObjAnteFac:this.ObjAnteFac,
contabilidad:this.contabilidad,
usuario:JSON.parse(JSON.stringify(this.$user)),
NombreImprementador:JSON.parse(sessionStorage.getItem("NombreImprementador"))
}


  this.$axios
    .post(
      this.$hostname +
        this.$hName +
        "/services/utilitarioFacturaVentas/saveOrUpdateFacturasVenta",
      JSON.parse(JSON.stringify(jsn))
    )
    .then(res => this.alerta("Dato guardado correctamente!", "bien"))
    .catch(error =>
      this.alerta("Dato no guardado","error"
        // "hubo un error , por favor verifique el campo descripcion!",
        // "error"
      )
    );*/

        EventBus.$emit("loading", true)
        var FACTURA = JSON.parse(JSON.stringify(this.UtilFacturaVentas))

        FACTURA.contabilidad = this.contabilidad
        FACTURA.fecha = FACTURA.fecha.trim().substr(0, 10) + "T04:00"

        if (FACTURA.contabilidad != null) {
          FACTURA.contabilidad.contabilidadDetalleList = this.RLisCuenta
        }

        this.$axios
            .post(this.$hostname + this.$hName + "/utilitarioFacturaVentas/saveOrUpdateFacturasVenta", FACTURA, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              this.aalert.estado = true
              this.aalert.color = "success"
              this.aalert.nombre = "Dato guardado correctamente!"
              EventBus.$emit("loading", false)
            })
            .catch((error) => {
              this.alerta("Reporte no Impreso(" + error + ")", "error")
              EventBus.$emit("loading", false)
            })
      } else {
        this.alerta("Los campos en rojo son requeridos", "error")
      }
    },

    remove() {
      if (this.UtilFacturaVentas.codigo != 0 && this.UtilFacturaVentas.codigo != null) {
        this.Elim_notif.estado = !this.Elim_notif.estado
      } else {
        this.alerta("Seleccione un tipo de cliente para eliminar", "error")
      }
    },
    eliminar() {
    },
    anular() {
      if (this.Elim_notif.estado) {
      }
    },
    imprimirList() {
    },
    newwnuevo() {
      this.selected = []
      ;(this.busquedaFacVent = {
        cliente: null,
        fechaInicial: fechaNueva(),
        fechaFinal: fechaNueva(),
        NoFactura: 0,
        documento: null,
        ncf: null,
        opcion: 0,
        buscarTrackId: "",
      }),
          (this.contabilidad = null),
          (this.RLisCuenta = [])
      ;(this.listFactVent = []),
          (this.facturasVentaList = []),
          (this.ObjAnteFac = null),
          (this.UtilFacturaVentas = {
            //fecha:new Date().toISOString().substr(0,10),
            fecha: "",
            documentoFactura: null,

            facturasventaPK: {
              secuencia: 0,
            },
            ncf: "",
            cliente: null,
            tipocomprobante: null,
            sucursal: null,

            cobertura: null,
            autorizacion: null,
            medico: null,
            coberturaPendiente: null,
            diascredito: 0,
            comentario: "",

            valordescuento: 0,
            valorimpuesto: 0,
            totalIsr: 0,
            totalOtroImpuesto: 0,
            valor: 0,

            efectivo: 0,
            cheques: 0,
            tarjeta: 0,
            transferencia: 0,
            valorNc: 0,

            cupones: 0,
            valorasignacion: 0,
            puntos: 0,
            valorbonogas: 0,
            cxc: 0,

            pendiente: 0,
            valordonacion: 0,
            valorPruebaMetro: 0,
            valorTraspaso: 0,
            valorPruebaMetro: 0,
            activada: true,
            enviada:false
          }),
          (this.Totales = {
            Cant: 0,
            Precio: 0,
            Impuresto: 0,
            Descuento: 0,
            Valor: 0,
          }),
          (this.TotalCuenta = {
            credito: 0,
            debito: 0,
          }),
          this.getFacVenta()

      EventBus.$emit("loading", false)
      //   EventBus.$emit("actualizaBarraBusqueda2");
    },

    NewReporte() {
      this.dialogReporte = false
    },

    imprimiir() {
      window.print()
    },

    Recalcular() {
      //this.getPdf()
      //this.dialogReporte=true
    },

    getCrear() {
    },

    sumaValor() {
    },

    resertPaginacion() {
      this.resertPagi = false

      this.paginator.page = 1
      this.paginator.pageStart = 0
      this.paginator.pageStop = this.paginator.itemsPerPage

      var _this = this
      setTimeout(function () {
        _this.resertPagi = true
      }, 500)

      //setTimeout(this.resertPagi=true,1500);
    },

    cargarPaginacion(e) {
      this.selected = []
      // console.log('cargarPaginacion')
      //     console.log(e);
      this.paginator = e

      if (this.paginator.itemsPerPage == -1) {
        this.paginator.itemsPerPage = 15
        // this.paginator.itemsPerPage.push(15)
      }

      this.getFacVenta()
      //   this.filtro();
    },

    restaurarFacVenta() {
      //facturasVentaList
      // cobertura: 0
      // costo: null
      // d: false
      // descripcion: "PRIMERIS 500 MG TABLETA X 21"
      // dp: 0
      // dv: 0
      // i: 0
      // ii: false
      // io: 0
      // lote: ""
      // maxDisc: 30
      // nmd: false
      // o: 0
      // precio: 3737.5
      // precioOrig: 3737.5
      // precioUnico: 3737.5
      // productos: {activo: true, borrado: false, calcularprecio: true, codigo: 15691, codigoanterior: "7035", …}
      // qt: 1
      // r: false
      // regalar: []
      // rp: 0
      // rv: 0
      // tasa: 1
      // tr: 2
      // unidades: {activado: true, codigo: 482, desactivo: false, descripcion: "CAJA", descripcionOriginal: "CAJA", …}
      // v: {}
      //volumen: 0

      if (this.UtilFacturaVentas.detalleJson.length > 0) {
        this.facturasVentaList = []

        var dtjson = JSON.parse(this.UtilFacturaVentas.detalleJson)

        dtjson.forEach((element) => {
          var obj = {
            //almacen:null,
            facturasProveedoresDetallePK: {oferta: false},
            //precioFactura: e.datos.costo,
            //impuesto:0,
            //unidad:e.datos.unidades,
            //impuestoIncluido: this.UtilFacturaProveedores.itbisincluido
            oferta: 0,
            ofertas: null,
            unidades: element.unidades,
            productos: element.productos,
            cantidad: element.qt,
            precio: element.precio,
            costo: element.costo,
            valordescuento: element.i,
            valorimpuesto: element.i,
            valor: 0,
            cantidadPendiente: element.qt,
            almacen: this.UtilFacturaVentas.sucursal.almacen.codigo,
            descuento: 0,
            valordescuento: 0,
            descuentoPorciento: false,
            descripcion: element.productos.descripcion,
          }

          this.facturasVentaList.push(obj)
        })

        //console.log('Mierrrr')
        //console.log(JSON.stringify(ListFP))

        //this.facturasVentaList=JSON.parse(JSON.stringify(ListFP))

        //restaurarFacProv

        //setTimeout(this.CalcularFactProv,200);
      }
    },

    factuVenList(e) {
      this.facturasVentaList.push(JSON.parse(JSON.stringify(e)))

      setTimeout(this.CalcularFact, 200)
    },

    BlurVerifCantPenCant(e) {
      e.cantidadPendiente = e.cantidad

      // if(e.hasOwnProperty('facturasventaDetallePK')){

      // this.alerta("Aparentemente  esta factura tiene una devolución (Revise)","error")

      // }
      // else{

      // }
    },

    ChangeDescPorc(e) {
      //descuentoPorciento,valordescuento,descuento
      if (e.descuentoPorciento == true) {
        e.descuento = e.valordescuento
        e.valordescuento = 0
      } else {
        e.valordescuento = e.descuento
        e.descuento = 0
      }

      setTimeout(this.CalcularFact, 200)
    },

    CalcularFact() {
      this.Totales = {
        Cant: 0,
        Precio: 0,
        Impuresto: 0,
        Descuento: 0,
        Valor: 0,
      }

      this.facturasVentaList.forEach((element) => {
        var des = 0

        if (element.descuentoPorciento == true) {
          des = (element.precio * element.cantidad * element.descuento) / 100
        } else {
          des = element.valordescuento
        }

        element.valor = element.precio * element.cantidad + element.valorimpuesto - des
        this.Totales.Cant += element.cantidad
        this.Totales.Precio += element.precio
        this.Totales.Impuresto += element.valorimpuesto
        this.Totales.Descuento += element.valordescuento

        this.Totales.Valor += element.valor
      })
    },

    GenerandoDatosFact(e) {
      this.UtilFacturaVentas = JSON.parse(JSON.stringify(e.UtilFacturaVentas))
      this.facturasVentaList = JSON.parse(JSON.stringify(e.facturasVentaList))
      this.ObjAnteFac = JSON.stringify(e.ObjAnteFac)

      this.calcularTotalcuenta()
      this.CalcularFact()
      //calcularTotalcuenta
    },

    calcularTotalcuenta(e) {
      this.TotalCuenta.credito = 0
      this.TotalCuenta.debito = 0

      if (e.toString().length > 0) {
        this.RLisCuenta.forEach((element) => {
          if (!element.hasOwnProperty("credito")) {
            element.credito = 0
          }

          if (!element.hasOwnProperty("debito")) {
            element.debito = 0
          }

          this.TotalCuenta.credito += element.credito
          this.TotalCuenta.debito += element.debito
        })
      }
    },

    deleProducto(item) {
      const index = this.facturasVentaList.indexOf(item)
      var eliminar = confirm("Desea eliminar este denominación?") && this.facturasVentaList.splice(index, 1)
      if (eliminar != false) {
        setTimeout(this.CalcularFact, 200)
        //this.CalcularDenominacion()
      }
    },

    KeyUpCantidad(e) {
      //  if(e.key.charCodeAt(0)>=48 & e.key.charCodeAt(0)<=57 ){}

      if (e.target.value.length == 0) {
        e.target.value = 0
      }

      if (e.key) {
        var mynumeral = require("numeral")
        e.target.value = mynumeral(e.target.value).value()

        //console.log(mynumeral(""+this.mensajero.metadeenvios)).value()
        if (e.target.value == null) {
          e.target.value = 0
        }
      } else {
        e.key = ""

        //console.log("no se puede poner letras o signos")
      }

      if (e.target.value.length == 0) {
        e.target.value = 0
        e.key = 0
      }
    },

    //Nota: recalcular balance al cliente seleccionado
    recalcularBalanceCliente() {
      // if(this.busquedaFacVent.cliente==null){

      // }
      this.Reparaloading = true

      /*this.$axios.post(this.$hostname + this.$hName + "/services/utilitarioFacturaVentas/recalcularBalanceCliente",
      {
        //descripcion:"",
          usuario:JSON.parse(JSON.stringify(this.$user)),
          datos:JSON.parse(JSON.stringify(this.UtilFacturaVentas.cliente))
      })
      .then(res => {

        var _this=this;
       setTimeout(function(){ _this.Reparaloading=false, _this.alertaNotf("Recalculo procesado ", "bien");

       }, 3000);


      })
      .catch(error =>{this.Reparaloading=true, this.alerta("Los campos en rojo son requeridos", "error")   });*/

      this.$axios
          .get(
              this.$hostname +
              this.$hName +
              `/utilitarioFacturaVentas/recalcularBalanceCliente/${this.UtilFacturaVentas.cliente.codigo}/`,
              {headers: this.$store.getters.GetheadersAxios},
          )
          .then((res) => {
            var _this = this
            setTimeout(function () {
              _this.Reparaloading = false
              _this.alertaNotf("Recalculo procesado ", "bien")
            }, 1000)
          })
          .catch((error) => {
            this.Reparaloading = false
            this.alerta("Error durante recalculo", "error")
            console.log(error)
          })
    },

    RecAgregarProducto(e) {
      if (e.estado == "cerrar") {
        this.dialogAddProducto = e.false
      }

      if (e.estado == "datos") {
        var obj = {
          //almacen:null,
          //facturasProveedoresDetallePK:{ oferta: false },
          //precioFactura: e.datos.costo,
          //impuesto:0,
          //unidad:e.datos.unidades,
          //impuestoIncluido: this.UtilFacturaProveedores.itbisincluido
          oferta: 0,
          ofertas: null,
          unidades: e.datos.unidades,
          productos: e.datos.productos,
          cantidad: 1,
          precio: e.datos.precio,
          costo: e.datos.costo,
          valordescuento: 0,
          valorimpuesto: 0,
          valor: 0,
          cantidadPendiente: 1,
          almacen: this.UtilFacturaVentas.sucursal.almacen.codigo,
          descuento: 0,
          valordescuento: 0,
          descuentoPorciento: false,
          descripcion: e.datos.productos.descripcion,
        }

        this.facturasVentaList.push(obj)
        setTimeout(this.CalcularFact, 200)
      }
    },

    getFacVenta() {
      // if(this.busquedaFacVent.NoFactura.length==0){this.busquedaFacVent.NoFactura=0}

      if(this.$store.getters.GetdatosInfUsu==null){
        return
      }

      if (
          (this.busquedaFacVent.NoFactura != null && this.busquedaFacVent.NoFactura.length == 0) ||
          this.busquedaFacVent.NoFactura == 0
      ) {
        this.busquedaFacVent.NoFactura = null
      }
      if (this.busquedaFacVent.ncf != null && this.busquedaFacVent.ncf.length == 0) {
        this.busquedaFacVent.ncf = null
      }

      if (this.$refs.formFactVenta.validate()) {
        /*this.$axios.post(this.$hostname + this.$hName + "/services/utilitarioFacturaVentas/ListFacturaVentas",
      {
         // descripcion:"",
          usuario:JSON.parse(JSON.stringify(this.$user)),
          datos:JSON.parse(JSON.stringify(this.busquedaFacVent)),
          PrimerRegistro: this.paginator.pageStart,
          paginacion: this.paginator.page,
          cantidad: this.paginator.itemsPerPage,
      })
      .then(res => {
        this.TotalRegistros = res.data.TotalRegistros,
        this.listFactVent = res.data.ListRecIngresos
      });*/

        /*
busquedaFacVent:{
cliente:null,
fechaInicial:new Date().toISOString().substr(0,10),
fechaFinal:new Date().toISOString().substr(0,10),
NoFactura:0,
documento:null,
ncf:null

},

var ConsultaFacturas: {
      documento:null,
      factura:null,
      ncf:null,
      sucursal:null,
      concepto:null,
      desde: new Date().toISOString().substr(0,10),
      hasta:new Date().toISOString().substr(0,10),
      //fechaCreacion: new,
    //  fechaModificacion: "",
    },

*/

        var obj = JSON.parse(JSON.stringify(this.busquedaFacVent))
        if (this.busquedaFacVent.documento != null) {
          obj.documento = this.busquedaFacVent.documento.codigo
        }
        if (this.busquedaFacVent.cliente != null) {
          obj.cliente = this.busquedaFacVent.cliente.codigo
        }
        obj.limit = this.paginator.itemsPerPage
        obj.ultimo = this.paginator.pageStart

        this.$axios
            .post(this.$hostname + this.$hName + "/utilitarioFacturaVentas/ConsultaFacturas", obj, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {

              // this.GetDataFact(res.data)
              ;(this.TotalRegistros = res.data.TbTotalItem), (this.listFactVent = res.data.ListFactura)
            })
            .catch((error) => {
              this.alerta("Reporte no Impreso(" + error + ")", "error")
            })
      } else {
        this.alerta("Los campos en rojo son requeridos", "error")
      }
    },

    GenerarContabilidad() {
      //Ganerando la contabilidada

      // if(this.UtilitarioContabBusqueda.documento==null){
      //   this.alerta("Seleccione un documento", "error")
      //   return 0;
      // }

      var Contb = {
        documento: this.UtilFacturaVentas.documentoFactura,
        NoSecuencia: this.UtilFacturaVentas.facturasventaPK.secuencia,
        operacion: {codigo: 27},
      }

      /*var _this=this;
this.$axios.post(this.$hostname+this.$hName+'/services/utilitarioContabilidad/GetContabilidad', {
datos:JSON.parse(JSON.stringify(Contb))
})


.then(res=>{ 

if(res.data.estado==true){this.alertaNotf("Dato generado correctamente!", "bien")
setTimeout(function(){ _this.BuscarContabilida()}, 5);
}
if(res.data.estado=="NoExist"){this.alertaNotf("Dato contable no generado (Factura no existe)", "error")}
if(res.data.estado==false){this.alertaNotf("Dato contable no generado correctamente!", "error")}
if(res.data.estado=="NoSecDocOp"){this.alerta("El número de secuencia no existe en el documento y operación seleccionada", "error")}
if(res.data.estado=="NoCodCont"){this.alerta("Este documento no posee codificación contable", "error")}
  })
.catch(error =>{this.alertaNotf("Dato no guardado"+error,"error")});*/

      this.BuscarContabilida()
    },

    BuscarContabilida() {
      //buscando la contabilidad que fue generada

      /*this.$axios.post(this.$hostname+this.$hName+'/services/utilitarioContabilidad/BuscarContabilidad',{
usuario:JSON.parse(JSON.stringify(this.$user)),
documento: this.UtilFacturaVentas.facturasventaPK.documento,
secuencia: this.UtilFacturaVentas.facturasventaPK.secuencia,
operacion:27
})
.then(res=>{ 
this.contabilidad=res.data,
this.RLisCuenta=JSON.parse(JSON.stringify(res.data.contabilidadDetalleList)),
this.calcularTotalcuenta(res.data.contabilidadDetalleList)
//this.contabilidad=res.data
})*/

      //setTimeout(this.CalcularFact,3);

      this.$axios
          .get(
              this.$hostname +
              this.$hName +
              "/contabilidad/findContabilidad/" +
              this.UtilFacturaVentas.facturasventaPK.documento +
              "/" +
              this.UtilFacturaVentas.facturasventaPK.secuencia +
              "/" +
              this.UtilFacturaVentas.documentoFactura.operacion.codigo,
              {headers: this.$store.getters.GetheadersAxios},
          )
          .then((res) => {
            if (res.data != null && res.data.toString().length > 0 && res.data.contabilidadDetalleList.length > 0) {
              this.contabilidad = res.data
              this.RLisCuenta = JSON.parse(JSON.stringify(res.data.contabilidadDetalleList))
              this.calcularTotalcuenta(res.data.contabilidadDetalleList)
              // this.contabilidad=JSON.parse(JSON.stringify(this.contabilidad)),
              // this.ObjAnteFac=JSON.stringify(obj)
            } else {
              this.CrearContabilidad(this.UtilFacturaVentas)
              // this.alerta("Esta factura no posee codificación contable", "error")
            }
          })
          .catch((error) => {
            this.alertaNotf("Dato no guardado" + error, "error")
          })

      setTimeout(this.CalcularFact, 3)
    },

    CrearContabilidad(FACTURA) {
      this.$axios
          .post(this.$hostname + this.$hName + "/utilitarioFacturaVentas/generarcontabilidad", FACTURA, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            // this.alerta("Dato guardado correctamente!", "bien")
            if (res.data.toString().length > 0) {
              this.contabilidad = res.data
              this.RLisCuenta = JSON.parse(JSON.stringify(res.data.contabilidadDetalleList))
              this.calcularTotalcuenta(res.data.contabilidadDetalleList)
              /*obj.contabilidad=JSON.parse(JSON.stringify(this.contabilidad)),
            this.ObjAnteFac=JSON.stringify(obj) */
            }
          })
          .catch((error) => {
            this.alerta("Reporte no Impreso(" + error + ")", "error")
            EventBus.$emit("loading", false)
          })
    },

    CCuentasContables(e, t) {
      //this.acti_Modal_cuenta=b

      // this.form.RLisCuenta= JSON.parse(JSON.stringify(e));
      // this.form.TotalCuenta=JSON.parse(JSON.stringify(t))

      this.RLisCuenta = JSON.parse(JSON.stringify(e))
      //this.form.RLisCuenta= this.RLisCuenta

      //this.TotalCuenta=JSON.parse(JSON.stringify(t))
    },

    getPdf() {
      const pdff =
          "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"

      this.pdf = this.base64ToArrayBuffer(pdff)
    },

    base64ToArrayBuffer(base64) {
      var binary_string = window.atob(base64)
      var len = binary_string.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i)
      }
      return bytes.buffer
    },

    CargarRalmacen() {
      this.$axios
          .get(this.$hostname + this.$hName + "/almacen/activos", {headers: this.$store.getters.GetheadersAxios})
          .then((res) => {
            this.Ralmacen = res.data
          })
    },

    SelctCbAlmacentbProd(item) {
      var _this = this
      setTimeout(function () {
        if (item.almacen == null) {
          item.almacen = ""
        }

        if (!item.almacen.hasOwnProperty("codigo")) {
          item.almacen = ""
          item.almacen = null
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }
      }, 300)

      /*if (item.almacen== null) {
      item.almacen = "";
    }

    if (item.almacen.codigo == undefined) {
      this.alerta("Seleccione un Almacén", "error");
      item.almacen = "";
      return;
    }*/
    },

    CargarRvendedor() {
      this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/findallactiv", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.Rvendedor = res.data
          })
    },

    SelctCbvendedor() {
      var _this = this
      setTimeout(function () {
        if (_this.UtilFacturaVentas.vendedor == null) {
          _this.UtilFacturaVentas.vendedor = ""
        }

        if (!_this.UtilFacturaVentas.vendedor.hasOwnProperty("codigo")) {
          _this.UtilFacturaVentas.vendedor = ""
          _this.UtilFacturaVentas.vendedor = null
          _this.alerta("Seleccione un vendedor", "error")
          return
        }
      }, 300)
    },

    CbFilvendedor(e) {
      if (e.target.value.length == 1) {
        if ((e.target.value.charCodeAt(0) >= 97) & (e.target.value.charCodeAt(0) <= 122)) {
          this.RfilVendedor = "nombre"

          this.CargarRvendedor()
        } else {
          this.RfilVendedor = "cedula"
        }

        if ((e.target.value.charCodeAt(0) >= 48) & (e.target.value.charCodeAt(0) <= 57)) {
          this.CargarRvendedor()

          this.RfilVendedor = "cedula"
        } else {
          this.RfilVendedor = "nombre"
        }

        //numero 48 a 57
        //letras 97 a 122
      }
    },

    cargarCliente() {
      this.$axios
          .get(this.$hostname + this.$hName + "/clientes/findtodo/a/3/25/0", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => (this.RCliente = res.data))
    },

    SelctCbClienteBuscar() {
      var _this = this
      setTimeout(function () {
        if (_this.busquedaFacVent.cliente == null) {
          _this.busquedaFacVent.cliente = ""
        }

        if (!_this.busquedaFacVent.cliente.hasOwnProperty("codigo")) {
          _this.busquedaFacVent.cliente = ""
          _this.busquedaFacVent.cliente = null
          _this.alerta("Seleccione un cliente", "error")
          return
        }
      }, 300)
    },

    SelctCbCliente() {
      var _this = this
      setTimeout(function () {
        if (_this.UtilFacturaVentas.cliente == null) {
          _this.UtilFacturaVentas.cliente = ""
        }

        if (!_this.UtilFacturaVentas.cliente.hasOwnProperty("codigo")) {
          _this.UtilFacturaVentas.cliente = ""
          _this.UtilFacturaVentas.cliente = null
          _this.alerta("Seleccione un cliente", "error")
          return
        }
      }, 300)
    },

    CbFilcliente(e) {
      if (e.target.value.length >= 0) {
        this.$axios
            .get(
                this.$hostname +
                this.$hName +
                "/clientes/findtodo/" +
                (e.target.value === null || e.target.value.length == 0 ? "A" : e.target.value) +
                "/3/25/0",
                {headers: this.$store.getters.GetheadersAxios},
            )
            .then((res) => (this.RCliente = res.data))
      }
    },

    ClienteSelect(e) {
      this.telefono = ""
      this.clientEmail = ""

      if (e != null) {
        if (e.hasOwnProperty("codigo")) {
          //this.ObjCliente=e
          //this.clientTel='Tel.'+e.cedrnc

          this.telefono = e.telefono
          this.clientEmail = e.correo
        } else {
          this.telefono = ""
          this.clientEmail = ""
        }
      }
    },

    cargarDocumento() {
      this.$axios
          .get(this.$hostname + this.$hName + "/documentoventas/findallActivos", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.RDocumento = res.data.filter((ee) => ee.operacion.codigo == 27)
          })
    },

    SelctCbDocumentoBuscar() {
      var _this = this
      setTimeout(function () {
        if (_this.busquedaFacVent.documento == null) {
          _this.busquedaFacVent.documento = ""
        }

        if (!_this.busquedaFacVent.documento.hasOwnProperty("codigo")) {
          _this.busquedaFacVent.documento = ""
          _this.busquedaFacVent.documento = null
          _this.alerta("Seleccione un documento", "error")
          return
        }
      }, 300)
    },

    SelctCbDocumento() {
      var _this = this
      setTimeout(function () {
        if (_this.UtilFacturaVentas.documento == null) {
          _this.UtilFacturaVentas.documento = ""
        }

        if (!_this.UtilFacturaVentas.documento.hasOwnProperty("codigo")) {
          _this.UtilFacturaVentas.documento = ""
          _this.UtilFacturaVentas.documento = null
          _this.alerta("Seleccione un documento", "error")
          return
        }
      }, 300)
    },

    cargarTipoComprobante() {
      this.$axios
          .get(this.$hostname + this.$hName + "/tiponcf/findallactivo", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.RtipoComprobante = res.data.filter((ee) => ee.pv == true)
          })
    },

    SelctCbTipoComprobante() {
      var _this = this
      setTimeout(function () {
        if (_this.UtilFacturaVentas.tipocomprobante == null) {
          _this.UtilFacturaVentas.tipocomprobante = ""
        }

        if (!_this.UtilFacturaVentas.tipocomprobante.hasOwnProperty("codigo")) {
          _this.UtilFacturaVentas.tipocomprobante = ""
          _this.UtilFacturaVentas.tipocomprobante = null
          _this.alerta("Seleccione un tipo de comprobante", "error")
          return
        }
      }, 300)
    },

    cargarCaja() {
      this.$axios
          .get(this.$hostname + this.$hName + "/cajas/findAllActivos", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => (this.RCaja = res.data))
    },

    cargarSucursal() {
      this.$axios
          .get(this.$hostname + this.$hName + "/sucursal/findallActivos/", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => (this.RSucursal = res.data))
    },

    SelctCbSucursal() {
      var _this = this
      setTimeout(function () {
        if (_this.UtilFacturaVentas.sucursal == null) {
          _this.UtilFacturaVentas.sucursal = ""
        }

        if (!_this.UtilFacturaVentas.sucursal.hasOwnProperty("codigo")) {
          _this.UtilFacturaVentas.sucursal = ""
          _this.UtilFacturaVentas.sucursal = null
          _this.alerta("Seleccione un sucursal", "error")
          return
        }
      }, 300)
    },

    SelctCbCaja() {
      var _this = this
      setTimeout(function () {
        if (_this.UtilFacturaVentas.caja == null) {
          _this.UtilFacturaVentas.caja = ""
        }

        if (!_this.UtilFacturaVentas.caja.hasOwnProperty("codigo")) {
          _this.UtilFacturaVentas.caja = ""
          _this.UtilFacturaVentas.caja = null
          _this.alerta("Seleccione un caja", "error")
          return
        }
      }, 300)
    },


    NotifrestaurarFacVenta() {
      var notif = {
        estado: true,
        nombre: "¿Seguro que desea restaurar los producto de esta factura?",
        Exec: "ResFacVent",
      }

      this.Exec_notif(notif)
    },

    Exec_notif(e) {
      //console.log(e)
      this.notif = JSON.parse(JSON.stringify(e))

      //this.Elim_notif.estado = !this.Elim_notif.estado;
    },

    BlurDesde() {
      if (this.busquedaFacVent.fechaInicial.toString().length == 0) {
        this.busquedaFacVent.fechaInicial = this.fechaNueva()
      }
    },

    BlurHasta() {
      if (this.busquedaFacVent.fechaFinal.toString().length == 0) {
        this.busquedaFacVent.fechaFinal = this.fechaNueva()
      }
    },

    activarModuloEletronica(FAC) {

      var BOOL_ACTIVA = false
      var activaSucursal = (FAC.hasOwnProperty("sucursal") && FAC.sucursal != null && FAC.sucursal.facturacionEletronica == true)
      if (FAC != null && FAC.hasOwnProperty("facturasventaPK") && FAC.facturasventaPK.secuencia > 0 && activaSucursal == true) {
        BOOL_ACTIVA = true
      }
      return BOOL_ACTIVA

    },


    actualizarFacEletronico(FAC) {

      if (FAC.activada == false) {
        this.alerta("ESTA FACTURA NO ESTA ACTIVO !!!.", "error")
        return
      }
      if (FAC.hasOwnProperty("trackId") && FAC.trackId != null && FAC.trackId.trim().length > 0 && FAC.trackId.toUpperCase().includes("ACEPTADO")) {
        this.alerta("ESTA FACTURA YA FUE ACEPTADA (Revise) !!!.", "error")
        return
      }


      this.$axios
          .get(this.$hostname + this.$hName + `/reimpresion/getFactura/${FAC.facturasventaPK.secuencia}/${FAC.facturasventaPK.documento}`, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.facturacionEletronicaGet(res.data)
          })
          .catch((error) => {
            this.alerta(error, "error")
          })

      return


    },

    async facturacionEletronicaGet(FACT) {

      if (typeof FACT.trackId === "string") {
        try {
          if (JSON.parse(FACT.trackId).origen === "TRANSPORTE") {
            this.alerta("Este comprobante se procesa desde Comprobantes e-CF en TransporNet para conservar su XML firmado.", "error")
            return
          }
        } catch (error) { /* Los registros anteriores pueden contener respuestas no JSON. */ }
      }

     if(FACT.hasOwnProperty('trackId') && FACT.trackId!=null && FACT.trackId.includes("Aceptado")){
      this.alerta("NOTA: La factura ya fue enviada. (REVISE)", "error")
      return
    }

      var TipoeCF = FACT.tipocomprobante.hasOwnProperty("tipoEcf") && FACT.tipocomprobante.tipoEcf != null ? FACT.tipocomprobante.tipoEcf : ""
      var resObjCompleto = null
      if (TipoeCF == 32 && FACT.valor < 250000) {
        resObjCompleto = await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_RFCE(FACT)
      } else {
        resObjCompleto = await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_ECF(FACT)
      }

      if (resObjCompleto.objtrackId.estado === "Rechazado") {
        var msj_Error = ""

        Promise.all(resObjCompleto.objtrackId.mensajes.map(async (element) => {
          msj_Error += ` *- COD:${element.codigo} :${element.valor} \n`
        }))

        this.alerta(msj_Error, "error")

        if(!FACT.hasOwnProperty('trackId') || FACT.hasOwnProperty('trackId') && FACT.trackId==null || FACT.trackId!=null && !FACT.trackId.includes("estado")){
          this.actualizarFAC_ELETRONICA(FACT, resObjCompleto)
        }
      
        return resObjCompleto
      }
//this.enviarImprimirFactura(FACT)
      this.actualizarFAC_ELETRONICA(FACT, resObjCompleto)

      return resObjCompleto
    },


    actualizarFAC_ELETRONICA(FACT, objCompTrackId) {
      var TRACK = objCompTrackId.objtrackId
      //delete TRACK["mensajes"]

      var objTrack = {
        documento: FACT.facturasventaPK.documento,
        secuencia: FACT.facturasventaPK.secuencia,
        fechafirmadgii: objCompTrackId.fechafirmadgii,
        qrdgii: objCompTrackId.qrdgii,
        signatureValue: objCompTrackId.signatureValue,
        trackId: JSON.stringify(TRACK),
      }


      this.$axios.post(this.$hostname + this.$hName + "/pv/actualizarFactEletronica",
          objTrack, {headers: this.$store.getters.GetheadersAxios})
          .then((res) => {

            if (objCompTrackId.objtrackId.estado.toUpperCase().includes("ACEPTADO")) {
              //this.datostabla(res.data)
              this.alertaNotf("FACTURA EMITIDA CORRECTAMENTE !!! ", "bien")

            }


            //   if(objCompTrackId.objtrackId.estado==="Aceptado"){
            // //  this.enviarImprimirFactura(res.data)
            //      this.obtenerDatoSelect(res.data)
            //   }

            //    if(objCompTrackId.objtrackId.estado==="Aceptado Condicional"){
            //   //this.enviarImprimirFactura(res.data)
            //   this.obtenerDatoSelect(res.data)
            //   }


          })
          .catch((error) => {
            console.log("actualizartoken no guardado correctamente-->", error)
          })

    },


    alertaNotf(e, l) {
      if (l == "bien") {
        ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)
        EventBus.$emit("loading", false)
        //this.new();
      }

      if (l == "error") {
        ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)

        this.ejecucion = false
        EventBus.$emit("loading", false)
      }
    },

    alerta(e, l) {
      if (l == "bien") {
        ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)

        this.newwnuevo()
      }

      if (l == "error") {
        ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)

        this.ejecucion = false
        EventBus.$emit("loading", false)
      }
    },

    currencyFormatter(number) {
      //return this.formatNumber(params) + ".00";

      if (number == null) {
        number = 0
      }
      return number
          .toFixed(2)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")

      ///return this.formatNumber(params);

      //return params;
    },

    FormatoFecha(params0) {
      var params

      if (params0 != null) {
        params = new Date(params0).toISOString().substr(0, 10)
        if (params != null) {
          if (params.length > 0) {
            return params.substring(8, 10) + "-" + params.substring(5, 7) + "-" + params.substring(0, 4)
          }
        }
      } else {
        params = "N/A"
      }
    },

    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data
      this.filtro()
    },

    async filtro() {
    },

    asignClaseFactura(val) {
      let isFacturaElectronica = val.ncf != null && val.ncf[0] === 'E'
      return {
        'factura-electronica': isFacturaElectronica
      }
    },
  },
  computed: {

    ActDescBtn() {
      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))

      if (this.UtilFacturaVentas.facturasventaPK.secuencia > 0) {
        //  var objjct
        this.EstadoBtn = {
          guardar: true,
          eliminar: false,
          anular: false,
          nuevo: true,
          imprimir: false,
          vercuenta: false,
          btnBarraDi: false,
          recalcular: false,
          imprimirPro: false,
        }
      }

      if (this.UtilFacturaVentas.facturasventaPK.secuencia <= 0) {
        this.disableInp = false
        //var objjct
        this.EstadoBtn = {
          guardar: false,
          eliminar: false,
          anular: false,
          nuevo: true,
          imprimir: false,
          vercuenta: false,
          btnBarraDi: false,
          recalcular: false,
          imprimirPro: false,
        }
      }

      //EventBus.$emit("ActDesaBotones", objjct);

      if (this.UtilFacturaVentas.cliente == null) {
        this.disableRecalBalClient = true
      } else {
        this.disableRecalBalClient = false
      }

      if (this.RLisCuenta.length == 0) {
        if (this.UtilFacturaVentas.facturasventaPK.secuencia > 0) {
          this.GenerarContloading = false
        } else {
          this.GenerarContloading = true
        }
      } else {
        this.GenerarContloading = true
      }

      if (this.UtilFacturaVentas.hasOwnProperty("detalleJson")) {
        if (this.UtilFacturaVentas.facturasventaPK.secuencia > 0) {
          this.disabledRestFacVenta = false
        } else {
          this.disabledRestFacVenta = true
        }
      } else {
        this.disabledRestFacVenta = true
      }
    },
  },
}
</script>

<style>
#ImputColorDisable {
  color: black;
}
</style>
